var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkPermission(["chartView_tuition_invoice2"])
    ? _c("div", { staticClass: "card-wrapper" }, [
        _c("div", { staticClass: "card-top" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "card-heading" }, [
              _vm._m(0),
              _c("div", [
                _c("p", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.currentChartTitle)),
                ]),
                _c("p", { staticClass: "card-subtitle" }, [
                  _vm._v("Thống kê theo tháng trong năm " + _vm._s(_vm.year)),
                ]),
                _c("div", { staticClass: "header-tags" }, [
                  _c("span", { staticClass: "header-tag" }, [
                    _vm._v(_vm._s(_vm.activeCategoryLabel)),
                  ]),
                  _c("span", { staticClass: "header-tag header-tag--soft" }, [
                    _vm._v(_vm._s(_vm.activeKidStatusLabel)),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "filter-row" }, [
            _c("div", { staticClass: "mode-switcher" }, [
              _c(
                "button",
                {
                  staticClass: "mode-chip",
                  class: { "mode-chip--active": _vm.activeChartMode === "all" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setChartMode("all")
                    },
                  },
                },
                [_vm._v("\n          Tổng quan\n        ")]
              ),
              _c(
                "button",
                {
                  staticClass: "mode-chip",
                  class: {
                    "mode-chip--active": _vm.activeChartMode === "computed",
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setChartMode("computed")
                    },
                  },
                },
                [_vm._v("\n          Đã hoàn thành\n        ")]
              ),
              _c(
                "button",
                {
                  staticClass: "mode-chip",
                  class: {
                    "mode-chip--active": _vm.activeChartMode === "notComputed",
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setChartMode("notComputed")
                    },
                  },
                },
                [_vm._v("\n          Chưa hoàn thành\n        ")]
              ),
            ]),
            _c("div", { staticClass: "filter-selects" }, [
              _c(
                "div",
                { staticClass: "filter-group" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("Phạm vi"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "input-common filter-select",
                      attrs: {
                        placeholder: "Trạng thái phiếu thu",
                        clearable: "",
                      },
                      on: { change: _vm.handleChangeChartOrder },
                      model: {
                        value: _vm.dataSearchChart.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearchChart, "category", $$v)
                        },
                        expression: "dataSearchChart.category",
                      },
                    },
                    _vm._l(_vm.categories, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "filter-group" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("Trạng thái học sinh"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-select filter-select--small",
                      attrs: { placeholder: "Trạng thái", clearable: "" },
                      on: { change: _vm.handleChangeKidStatus },
                      model: {
                        value: _vm.kidStatusForStatistic,
                        callback: function ($$v) {
                          _vm.kidStatusForStatistic = $$v
                        },
                        expression: "kidStatusForStatistic",
                      },
                    },
                    _vm._l(
                      _vm.listKidStatusForStatistic,
                      function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { value: item.key, label: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm.summaryCards.length
            ? _c(
                "div",
                { staticClass: "summary-row" },
                _vm._l(_vm.summaryCards, function (summary) {
                  return _c(
                    "div",
                    {
                      key: summary.label,
                      staticClass: "summary-card",
                      style: { "--summary-accent": summary.color },
                    },
                    [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v(_vm._s(summary.label)),
                      ]),
                      _c("strong", { staticClass: "summary-value" }, [
                        _vm._v(_vm._s(summary.value)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "chart-shell" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "chart-content" }, [_vm._m(1)])
            : _vm.hasData
            ? _c("div", { staticClass: "chart-content" }, [
                _c(
                  "div",
                  { staticClass: "chartFees" },
                  [
                    _c("div", { staticClass: "chart-caption" }, [
                      _c("span", { staticClass: "chart-caption__dot" }),
                      _c("span", [_vm._v(_vm._s(_vm.chartCaption))]),
                    ]),
                    _c("ChartBar", {
                      attrs: {
                        checkLable: true,
                        chartData: _vm.currentChartConfig.chartData,
                        options: _vm.currentChartConfig.options,
                        height: 400,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _c("div", { staticClass: "chart-content chart-empty" }, [
                _vm._m(2),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-icon" }, [
      _c("i", { staticClass: "el-icon-s-marketing" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--loading" }, [
      _c("i", { staticClass: "el-icon-loading state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Đang tải dữ liệu biểu đồ"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v("Hệ thống đang đồng bộ dữ liệu phiếu thu học phí theo tháng."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--empty" }, [
      _c("i", { staticClass: "el-icon-document-delete state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Chưa có dữ liệu phiếu thu học phí"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v("Thử đổi chế độ xem hoặc bộ lọc để hiển thị thêm thống kê."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }